<template>
  <div style="border-bottom: 1px solid black">
    <v-layout row wrap>
      <v-flex xs12>
        <h3 class="title pa-2 mb-4" style="text-decoration: underline;">{{ title }}</h3>
      </v-flex>
      <v-flex xs12 lg4 px-2>
        <v-text-field
          name="name"
          label="First and last name"
          :rules="title !== 'Enrolling Parent' ? noRules : parentNameRules"
          box
          v-model="name"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6 lg4 px-2>
        <v-text-field
          name="phone"
          label="Phone"
          :rules="title !== 'Enrolling Parent' ? noRules : phoneRules"
          box
          mask="(###) ### - ####"
          v-model="phone"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6 lg4 px-2>
        <v-radio-group
          v-model="phone_type"
          row
          :rules="title !== 'Enrolling Parent' ? noRules : validationRules"
          :class="{ 'radio-group-spacing' : $vuetify.breakpoint.smAndDown }"
        >
          <v-radio label="cell" value="cell"></v-radio>
          <v-radio label="home" value="home"></v-radio>
          <v-radio label="work" value="work"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md6 lg2 px-2 order-xs3 order-lg1>
        <v-select
          name="contact_order"
          label="Contact Order"
          :rules="title !== 'Enrolling Parent' ? noRules : contactOrderRules"
          box
          :items="contact_order_list"
          v-model="contact_order"
        ></v-select>
      </v-flex>
      <v-flex xs12 md6 lg2 px-2 order-xs4 order-lg2>
        <v-select
          name="gender"
          label="Gender"
          box
          :items="genders"
          :rules="title !== 'Enrolling Parent' ? noRules : genderRules"
          v-model="gender"
        ></v-select>
      </v-flex>
      <v-flex xs12 md6 lg4 px-2 order-xs1 order-lg3>
        <v-text-field
          name="alt_phone"
          label="Alternate Phone"
          box
          mask="(###) ### - ####"
          v-model="alt_phone"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6 lg4 xl3 px-2 order-xs2 order-lg4>
        <v-radio-group
          v-model="alt_phone_type"
          row
          :class="{ 'radio-group-spacing' : $vuetify.breakpoint.smAndDown }"
        >
          <v-radio label="cell" value="cell"></v-radio>
          <v-radio label="home" value="home"></v-radio>
          <v-radio label="work" value="work"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <h3 class="subheading px-2">Relationship</h3>
      </v-flex>
      <v-flex xs12 px-2>
        <v-radio-group
          class="mt-0 pt-0"
          :rules="title !== 'Enrolling Parent' ? noRules : validationRules"
          v-model="relationship"
          row
        >
          <v-radio label="Parent" value="parent"></v-radio>
          <v-radio label="Stepparent" value="stepparent"></v-radio>
          <v-radio label="Grandparent" value="grandparent"></v-radio>
          <v-radio label="Foster Parent" value="fosterparent"></v-radio>
          <v-radio label="Legal Guardian" value="legalguardian"></v-radio>
          <v-layout row>
            <v-radio label="Other" value="other"></v-radio>
            <v-text-field :disabled="!is_relationship_other" v-model="relationship_other"></v-text-field>
          </v-layout>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md6 lg4 px-2>
        <v-text-field
          name="address_1"
          label="Address"
          :rules="title !== 'Enrolling Parent' ? noRules : addressRules"
          box
          v-model="address"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6 lg4 px-2>
        <v-text-field
          name="employer"
          :rules="title !== 'Enrolling Parent' ? noRules : employerRules"
          label="Employer"
          box
          v-model="employer"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6 lg4 px-2>
        <v-text-field
          name="email"
          label="Email"
          :rules="title !== 'Enrolling Parent' ? noRules : emailRules"
          box
          v-model="email"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    order: {
      type: String
    }
  },
  data() {
    return {
      contact_order_list: [
        {
          text: "1st",
          value: 1
        },
        {
          text: "2nd",
          value: 2
        },
        {
          text: "3rd",
          value: 3
        },
        {
          text: "4th",
          value: 4
        }
      ],
      genders: ["Male", "Female"],
      noRules: [],
      validationRules: [v => !!v || "Field is required"],
      parentNameRules: [v => !!v || "Parent name is required"],
      phoneRules: [v => !!v || "Phone number is required"],
      contactOrderRules: [v => !!v || "Contact is required"],
      genderRules: [v => !!v || "Gender is required"],
      addressRules: [v => !!v || "Address is required"],
      employerRules: [v => !!v || "Employer is required"],
      emailRules: [v => /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(v) || "A valid email is required"],
    };
  },
  computed: {
    is_relationship_other() {
      return (
        this.$store.state.registration.parents["parent_" + this.order]
          .relationship === "other"
      );
    },
    relationship_other: {
      get() {
        return this.$store.state.registration.parents["parent_" + this.order]
          .relationship_other;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit("registration/parents/setRelationshipOther", payload);
      }
    },
    name: {
      get() {
        return this.$store.state.registration.parents["parent_" + this.order]
          .name;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit("registration/parents/setName", payload);
      }
    },
    phone: {
      get() {
        return this.$store.state.registration.parents["parent_" + this.order]
          .phone;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit("registration/parents/setPhone", payload);
      }
    },
    phone_type: {
      get() {
        return this.$store.state.registration.parents["parent_" + this.order]
          .phone_type;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit("registration/parents/setPhoneType", payload);
      }
    },
    alt_phone: {
      get() {
        return this.$store.state.registration.parents["parent_" + this.order]
          .alt_phone;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit("registration/parents/setAltPhone", payload);
      }
    },
    alt_phone_type: {
      get() {
        return this.$store.state.registration.parents["parent_" + this.order]
          .alt_phone_type;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit("registration/parents/setAltPhoneType", payload);
      }
    },
    contact_order: {
      get() {
        return this.$store.state.registration.parents["parent_" + this.order]
          .contact_order;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit("registration/parents/setContactOrder", payload);
      }
    },
    gender: {
      get() {
        return this.$store.state.registration.parents["parent_" + this.order]
          .gender;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit("registration/parents/setGender", payload);
      }
    },
    relationship: {
      get() {
        return this.$store.state.registration.parents["parent_" + this.order]
          .relationship;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit("registration/parents/setRelationship", payload);
      }
    },
    address: {
      get() {
        return this.$store.state.registration.parents["parent_" + this.order]
          .address;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit("registration/parents/setAddress", payload);
      }
    },
    employer: {
      get() {
        return this.$store.state.registration.parents["parent_" + this.order]
          .employer;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit("registration/parents/setEmployer", payload);
      }
    },
    email: {
      get() {
        return this.$store.state.registration.parents["parent_" + this.order]
          .email;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit("registration/parents/setEmail", payload);
      }
    }
  }
};
</script>

<style scoped>
.radio-group-spacing {
  margin-top: -15px;
  padding-bottom: 20px;
}
</style>
